import React from 'react';
import { useSelector } from 'react-redux';
import WarrantyDocumentsContainer from '../containers/warranty-documents-container';
import WarrantyInfo from '../components/warranty-info';

const WarrantyPanel = ({ requestId, canChange, ...props }) => {
  const { CanChangeWarranty: canChangeWarranty } = useSelector(
    (state) => state.authentication.userInfo
  );

  return (
    <div {...props}>
      <WarrantyInfo
        style={{ marginLeft: '40px' }}
        request={requestId}
        canChangeWarranty={canChange && canChangeWarranty}
      />
      <WarrantyDocumentsContainer
        style={{ marginLeft: '40px' }}
        request={requestId}
        canChangeWarranty={canChange && canChangeWarranty}
      />
    </div>
  );
};

export default WarrantyPanel;
